module.exports = __webpack_public_path__ + "faaf3b858c8d25fee85f67dfef59868e.MP3";